import React from 'react';
import { FaRegFileAlt } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import { AiOutlineDelete } from 'react-icons/ai';
import { RiLink } from 'react-icons/ri';

interface IProps {
  documentList: {
    uuid: string;
    type: string;
    name: string;
    errorMessage: string | null;
  }[];
  deleteDocuments: any;
  handleEditUrl: any;
}

const FaqFillScreen = (props: IProps) => {
  const { documentList, deleteDocuments, handleEditUrl } = props;

  return (
    <div className="pl-1.5 grid grid-cols-[repeat(auto-fit,minmax(110px,0fr))] gap-5 pb-4">
      {documentList.map((info: any) => (
        <div className="mt-5" key={info.uuid}>
          <div
            className={`lg:w-35 lg:h-35 w-[110px] h-[110px] border-[3px] rounded-lg ${info.faqErr ? 'border-[#ff4c4c]' : 'border-[#006BEA]'}`}
          >
            <div className="flex gap-4 justify-end mr-2 mt-2 left-1 cursor-pointer">
              {info.type === 'Link' && (
                <FiEdit
                  className="md:h-4 md:w-4 h-4 w-4 text-[#006BEA]"
                  onClick={() => handleEditUrl(info)}
                />
              )}
              <AiOutlineDelete
                className="md:h-4 md:w-4 h-4 w-4 text-[#FA0000]"
                onClick={() => deleteDocuments(info.uuid)}
              />
            </div>
            <div className="h-3/5 flex justify-center items-center text-[#006BEA]">
              {info.type === 'Link' ? (
                <RiLink className="lg:w-8 lg:h-8 w-7 h-7" />
              ) : (
                <FaRegFileAlt className="lg:w-8 lg:h-8 w-7 h-7" />
              )}
            </div>
          </div>
          <div className="flex justify-start">
            <p className="lg:text-sm lg:w-28  w-[110px]  text-[13px] font-light leading-[28.13px] text-[#ffffff] truncate text-center">
              {info.name}
            </p>
          </div>
          <p className="lg:text-sm text-[13px] leading-[28.13px] text-[#ff4c4c] text-center">
            {info.faqErr && `Invalid ${info.type}`}
          </p>
        </div>
      ))}
    </div>
  );
};
export default FaqFillScreen;
